export default {
  namespaced: true,
  state: {
    chosenPlatforms: [],
    publishedPlatforms: [],
    platforms: [],
    currentPlatform: null,
    selectedPlatform: null,
    blueprints: {}
  },
  mutations: {
    ADD_PLATFORM (state, platform) {
      state.chosenPlatforms.push(platform)
    },
    REMOVE_PLATFORM (state, platform) {
      state.chosenPlatforms = state.chosenPlatforms
        .filter(chosenPlatform => chosenPlatform.displayName !== platform.displayName)
    },
    CLEAR_CHOSEN_PLATFORMS (state) {
      state.chosenPlatforms = []
    },
    SET_PLATFORMS_FROM_FIREBASE (state, platforms) {
      state.platforms = platforms
    },
    SET_PUBLISHED_PLATFORMS (state, publishedPlatforms) {
      state.publishedPlatforms = publishedPlatforms
    },
    SET_CURRENT_PLATFORM (state, platformToView) {
      state.currentPlatform = Object.assign({}, platformToView)
    },
    CLEAR_CURRENT_PLATFORM (state) {
      state.currentPlatform = null
    },
    SET_SELECTED_PLATFORM (state, platformToSelect) {
      state.selectedPlatform = Object.assign({}, platformToSelect)
    },
    CLEAR_SELECTED_PLATFORM (state) {
      state.selectedPlatform = null
    },
    SET_PRODUCTS_CACHE (state, sortedPlatforms) {
      state.products = Object.assign({}, sortedPlatforms)
    }
  },
  actions: {
    togglePlatform ({ commit, state }, platformToToggle) {
      return new Promise((resolve, reject) => {
        const isDuplicate = state.chosenPlatforms.find((platform) => {
          return platform.displayName === platformToToggle.displayName
        })

        if (!isDuplicate) {
          if (state.chosenPlatforms.length === 3) {
            reject(platformToToggle)
            return false
          }
          commit('ADD_PLATFORM', platformToToggle)
          resolve({
            ...platformToToggle,
            status: 'add',
            inCart: state.chosenPlatforms.length
          })
        } else {
          commit('REMOVE_PLATFORM', platformToToggle)
          resolve({
            ...platformToToggle,
            status: 'remove',
            inCart: state.chosenPlatforms.length
          })
        }
      })
    },
    addPlatform ({ commit, state }, platformToAdd) {
      const isDuplicate = state.chosenPlatforms.find((platform) => {
        return platform['displayName'] === platformToAdd['displayName']
      })

      if (!isDuplicate && state.chosenPlatforms.length < 3) {
        commit('ADD_PLATFORM', platformToAdd)
      }
    },
    removePlatform ({ commit, state }, platformToRemove) {
      commit('REMOVE_PLATFORM', platformToRemove)
    },
    clearChosenPlatforms ({ commit }) {
      commit('CLEAR_CHOSEN_PLATFORMS')
    },
    setPlatforms ({ commit }, platforms) {
      commit('SET_PLATFORMS_FROM_FIREBASE', platforms)
    },
    setCurrentPlatform ({ commit, state }, platformToView) {
      // if (state.currentPlatform && (state.currentPlatform['.key'] === platformToView['.key'])) {
      //   commit('CLEAR_CURRENT_PLATFORM')
      //   return
      // }
      commit('SET_CURRENT_PLATFORM', platformToView)
    },
    clearCurrentPlatform ({ commit }) {
      commit('CLEAR_CURRENT_PLATFORM')
      return Promise.resolve()
    },
    platformSelection ({ commit }, platformToSelect) {
      commit('SET_SELECTED_PLATFORM', platformToSelect)
    },
    clearPlatformSelection ({ commit }) {
      commit('CLEAR_SELECTED_PLATFORM')
    },
    setProductsCache ({ commit }, sortedProducts) {
      commit('SET_PRODUCTS_CACHE', sortedProducts)
    }
  },
  getters: {
    lookupPlatform: state => {
      return platformKey => state.platforms.filter(platform => {
        return platform['.key'] === platformKey
      })
    },
    getPlatforms: state => state.platforms,
    getChosenPlatforms: state => state.chosenPlatforms,
    currentPlatform: state => state.currentPlatform,
    selectedPlatform: state => state.selectedPlatform
  }
}



// WEBPACK FOOTER //
// ./src/store/platforms.js